var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"filterable":"","placeholder":_vm.placeholder,"value-key":'id'},model:{value:(_vm.setGardener),callback:function ($$v) {_vm.setGardener=$$v},expression:"setGardener"}},_vm._l((_vm.gardeners),function(gardener){return _c('el-option',{key:gardener.id,attrs:{"label":_vm.formatName(gardener.name),"value":gardener}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }